import styled from "styled-components";
import { ReactComponent as CrossIcon } from "../../assets/cross_icon.svg";
import { BASIC_YELLOW } from "../../constants/colors";

type Props = {
  onCancel: () => void;
};

export const AppCouponHeader: React.FC<Props> = ({ onCancel }) => {
  return (
    <AppCouponHeaderContainer>
      <AppCouponText>アプリクーポン使用中</AppCouponText>

      <AppCouponButton onClick={onCancel}>
        <AppCouponText>キャンセル</AppCouponText>

        <AppCouponClose>
          <CrossIcon />
        </AppCouponClose>
      </AppCouponButton>
    </AppCouponHeaderContainer>
  );
};

const AppCouponHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: ${BASIC_YELLOW};
  padding: 14px;
`;

const AppCouponText = styled.div`
  margin: 0px;
  font-size: 14px;
  font-weight: 300;
`;

const AppCouponButton = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 14px;
  font-weight: 300;
  cursor: pointer;
`;

const AppCouponClose = styled.div`
  width: 10px;
  margin-left: 5px;
`;
